import folderStore from 'owa-folders';
import { select } from 'satcheljs/lib/legacy';
import { isUnderDistinguishedFolder } from 'owa-folders';
export default select({
    folderTable: function () { return folderStore.folderTable; },
})(function isFolderUnderDeletedItemsFolder(folder, distinguishedFolderId, state) {
    return isUnderDistinguishedFolder(folder, distinguishedFolderId, state);
});
//# sourceMappingURL=isFolderUnderDeletedItemsFolder.js.map